import React, { useRef } from 'react'
import './Leadership.css';

import Priyanka from './images/Leadership/2022-2023/Priyanka.jpg';
import Vanya from './images/Leadership/2022-2023/Vanya.png';
import Taneesha from './images/Leadership/2022-2023/Taneesha.jpg';
import Maya from './images/Leadership/2022-2023/Maya.png';
import Akshaya from './images/Leadership/2022-2023/Akshaya.jpg';
import Jessia from './images/Leadership/2022-2023/Jessia.jpg';
import Prakshi from './images/Leadership/2022-2023/Prakshi.jpg';
import Mumina from './images/Leadership/2022-2023/Mumina.jpg';
import Emily from './images/Leadership/2022-2023/Emily.png';
import Swara from './images/Leadership/2022-2023/Swara.jpg';
import Divya from './images/Leadership/2022-2023/Divya.jpg';

import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiCameraSwitchFill, RiInstagramFill} from 'react-icons/ri'

const Combio = () => {
  const ref = useRef(null);
  return (
    <><div>
      <div>
        <div>
          <div className='teamTitle-wrapper'>
            <p id="teamTitle">Committees 2024 - 2025</p>
          </div>
        </div>
        <div class="members">
        <div className='committee__container'>
            <h4 class="teamName">
                <b>Social Media Committee</b>
              </h4>
            <p>The WiC Social Media Committee manages WiC’s social media platforms, 
            including the WiC website, Instagram, Facebook, and Discord server. 
            They also take photos during WiC events and create social media graphics 
            and posters for WiC events. See more of the WiC Social Media Committee’s 
            work on our various social media accounts and platforms!</p>
        </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Priyanka} alt="Priyanka Mungra" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Priyanka Mungra</b>
              </h4>
              <p class='role'>Social Media Committee Member</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Vanya} alt="Vanya Jain" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Vanya Jain</b>
              </h4>
              <p class='role'>Social Media Committee Member</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Taneesha} alt="Taneesha Sharmin" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Taneesha Sharmin</b>
              </h4>
              <p class='role'>Social Media Committee Member</p>
            </div>
          </div>

          <div className='committee__container'>
            <h4 class="teamName">
                <b>Public Relations Committee</b>
              </h4>
            <p>The WiC Public Relations Committee is in charge of planning career events, which aim to offer engaging and unique career development 
            opportunities to WiC members. Events from the 2023-24 school year include the 
            Winter Affiliates Dinner, Uber Technical Interview Workshop, 
            Women in Tech Panel with Pinterest, and Preparing for the Summer with The Trade Desk.</p>
            </div>

            <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Maya} alt="Maya Bhat" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Maya Bhat</b>
              </h4>
              <p class='role'>Public Relations Committee Member</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Akshaya} alt="Akshaya Akkugari" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Akshaya Akkugari</b>
              </h4>
              <p class='role'>Public Relations Committee Member</p>
            </div>
          </div>


         <div className='committee__container'>
            <h4 class="teamName">
                <b>Social Events Committee</b>
              </h4>
            <p>As a team, the Social Events committee focuses on organizing engaging 
            and enjoyable Member Meetings for the WiC community at the Allen school 
            every quarter. These events have included self-care nights, craft nights, 
            and trivia nights, among others. Collaborating closely with the rest of the 
            executive team, we carefully select dates, scout venues, and design 
            activities to foster a strong sense of community and bring everyone closer 
            together.
            </p>
            </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Jessia} alt="Jessia Huang" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Jessia Huang</b>
              </h4>
              <p class='role'>Social Events Committee Member</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Prakshi} alt="Prakshi Shukla" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Prakshi Shukla</b>
              </h4>
              <p class='role'>Social Events Committee Member</p>
            </div>
          </div>

            <div className='committee__container'>
            <h4 class="teamName">
                <b>Outreach Committee</b>
              </h4>
            <p>The WiC Outreach Committee organizes events and workshops for middle and 
            high schoolers that introduce them to computer science and technology. 
            In the past, they organized the Launch Your Future outreach event which focused on 
            the intersection of Computer Science and Entrepreneurship. 
            Also, they hosted a startup founder panel, DubHacks Next panel, and a HTML workshop.</p>
            </div>      

            <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Mumina} alt="Mumina Guled" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Mumina Guled</b>
              </h4>
              <p class='role'>Outreach Committee Member</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Emily} alt="Emily Chi" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Emily Chi</b>
              </h4>
              <p class='role'>Outreach Committee Member</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Swara} alt="Swara Ramesh" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Swara Ramesh</b>
              </h4>
              <p class='role'>Outreach Committee Member</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={Divya} alt="Divya Ramu" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Divya Ramu</b>
              </h4>
              <p class='role'>Outreach Committee Member</p>
            </div>
          </div>

        

          
        </div>

      </div>
    </div>
    <div className='actions' ref={ref}>
    <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' class='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank'  class='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
         <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' target='_blank' rel="noreferrer"><RiInstagramFill /></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' target='_blank' rel="noreferrer"><BsFacebook /></a>
          <a id='discord' href='https://discord.gg/Zp4GVB7ddq' target='_blank' rel="noreferrer"><BsDiscord /></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" class='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
    </div></>
  )
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Combio;
